import type { NavItem, CategoryItem, ContentItem, BannerItem } from '@/types';

export const NAV_ITEMS: NavItem[] = [
  { label: '首页', href: '/' },
  { label: '电影', href: '/category/dianying' },
  { label: '电视剧', href: '/category/dianshiju' },
  { label: '综艺', href: '/category/zongyi' },
  { label: '动漫', href: '/category/dongman' },
  { label: '关于我们', href: '/about' },
];

export const CATEGORY_ALL: CategoryItem[] = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line', color: 'primary' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line', color: 'accent' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line', color: 'secondary' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', color: 'primary' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-film-line', color: 'accent' },
  { slug: 'jingsong', name: '惊悚片', icon: 'ri-ghost-line', color: 'secondary' },
];

export const BANNERS: BannerItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    description: '太阳急速老化，人类面临前所未有的生存危机，联合政府决定启动"流浪地球计划"...',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20scene%20with%20a%20giant%20planet%20earth%20glowing%20in%20deep%20space%2C%20massive%20engine%20thrusters%20firing%20blue%20flames%2C%20dark%20cosmic%20background%20with%20stars%2C%20dramatic%20lighting%2C%20epic%20movie%20poster%20style%2C%20no%20text&width=1600&height=700&seq=banner-1-2026&orientation=landscape',
    rating: 9.5,
    tag: '热播中',
    href: '/article/liulangdiqiu3',
  },
  {
    id: 2,
    title: '庆余年3',
    description: '范闲在大东山事件后身世之谜被揭开，各方势力暗流涌动，京都风云再起...',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20a%20mysterious%20figure%20in%20traditional%20robes%20standing%20under%20moonlight%2C%20dramatic%20shadows%2C%20foggy%20atmosphere%2C%20cinematic%20lighting%2C%20historical%20drama%20aesthetic%2C%20no%20text&width=1600&height=700&seq=banner-2-2026&orientation=landscape',
    rating: 9.2,
    tag: '热播中',
    href: '/article/qingyunian3',
  },
  {
    id: 3,
    title: '狂飙2：暗流',
    description: '扫黑除恶专项斗争持续深入，新一季的故事聚焦金融犯罪与网络黑产...',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20skyline%20at%20night%20with%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20mysterious%20atmosphere%2C%20crime%20thriller%20mood%2C%20cinematic%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1600&height=700&seq=banner-3-2026&orientation=landscape',
    rating: 9.0,
    tag: '新上线',
    href: '/article/kuangbiao2',
  },
];

export const FEATURED_CONTENT: ContentItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    slug: 'liulangdiqiu3',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20a%20massive%20spaceship%20in%20deep%20space%20with%20blue%20engine%20glow%2C%20dramatic%20cinematic%20lighting%2C%20dark%20cosmic%20background%2C%20movie%20poster%20aesthetic%2C%20no%20text&width=600&height=800&seq=featured-1&orientation=portrait',
    rating: 9.5,
    year: 2026,
    description: '太阳急速老化，持续膨胀。一百年后，太阳将膨胀到地球轨道，人类面临灭顶之灾...',
    tags: ['科幻', '灾难', '冒险'],
    updateInfo: '更新至高清完整版',
  },
  {
    id: 2,
    title: '庆余年3',
    slug: 'qingyunian3',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20style%2C%20a%20scholar%20in%20traditional%20robes%20holding%20a%20scroll%2C%20ancient%20palace%20background%2C%20dramatic%20lighting%2C%20elegant%20composition%2C%20no%20text&width=600&height=800&seq=featured-2&orientation=portrait',
    rating: 9.2,
    year: 2026,
    description: '范闲在大东山事件后，身世之谜逐渐揭开。各方势力暗流涌动，京都风云再起...',
    tags: ['古装', '权谋', '剧情'],
    updateInfo: '更新至第36集',
  },
  {
    id: 3,
    title: '狂飙2：暗流',
    slug: 'kuangbiao2',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20two%20men%20in%20dark%20suits%20standing%20in%20a%20modern%20city%20at%20night%2C%20rainy%20street%2C%20neon%20reflections%2C%20intense%20atmosphere%2C%20movie%20poster%20style%2C%20no%20text&width=600&height=800&seq=featured-3&orientation=portrait',
    rating: 9.0,
    year: 2026,
    description: '扫黑除恶专项斗争持续深入，新一季聚焦金融犯罪与网络黑产背后的保护伞...',
    tags: ['犯罪', '悬疑', '剧情'],
    updateInfo: '更新至第24集',
  },
  {
    id: 4,
    title: '封神第二部',
    slug: 'fengshen2',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%2C%20ancient%20warriors%20in%20armor%20battling%20with%20magical%20weapons%2C%20epic%20battle%20scene%2C%20dramatic%20sky%20with%20lightning%2C%20no%20text&width=600&height=800&seq=featured-4&orientation=portrait',
    rating: 8.8,
    year: 2026,
    description: '殷商大军压境，西岐将士浴血奋战。姜子牙率众仙迎战，封神大战一触即发...',
    tags: ['奇幻', '动作', '神话'],
    updateInfo: '更新至高清完整版',
  },
  {
    id: 5,
    title: '乘风破浪的姐姐5',
    slug: 'chengfengpolang5',
    category: '综艺',
    categorySlug: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20elegant%20women%20performers%20on%20a%20glamorous%20stage%20with%20spotlights%2C%20colorful%20costumes%2C%20entertainment%20show%20aesthetic%2C%20vibrant%20energy%2C%20no%20text&width=600&height=800&seq=featured-5&orientation=portrait',
    rating: 8.5,
    year: 2026,
    description: '全新一季，30位姐姐再次集结，用舞台证明年龄只是数字...',
    tags: ['综艺', '音乐', '竞演'],
    updateInfo: '更新至第8期',
  },
  {
    id: 6,
    title: '哪吒之魔童闹海',
    slug: 'nezha2',
    category: '动漫',
    categorySlug: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%2C%20a%20mythical%20boy%20with%20fire%20powers%20riding%20on%20a%20dragon%2C%20epic%20ocean%20storm%20background%2C%20vibrant%20colors%2C%20dynamic%20action%20scene%2C%20no%20text&width=600&height=800&seq=featured-6&orientation=portrait',
    rating: 9.3,
    year: 2026,
    description: '哪吒与敖丙在天劫之后，灵魂得以保全。但更大的危机正在海底酝酿...',
    tags: ['动画', '奇幻', '冒险'],
    updateInfo: '更新至高清完整版',
  },
];

export const LATEST_CONTENT: ContentItem[] = [
  {
    id: 7,
    title: '三体：黑暗森林',
    slug: 'santi2',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%2C%20mysterious%20cosmic%20scene%20with%20three%20suns%20in%20a%20dark%20space%2C%20abstract%20geometric%20patterns%2C%20intellectual%20sci-fi%20aesthetic%2C%20minimal%20design%2C%20no%20text&width=600&height=800&seq=latest-1&orientation=portrait',
    rating: 8.9,
    year: 2026,
    description: '面壁计划启动，四位面壁者与三体文明展开了一场跨越光年的智慧博弈...',
    tags: ['科幻', '悬疑', '剧情'],
    updateInfo: '更新至第12集',
  },
  {
    id: 8,
    title: '孤注一掷2',
    slug: 'guzhuyizhi2',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20a%20person%20trapped%20behind%20iron%20bars%20in%20a%20dark%20room%2C%20gloomy%20atmosphere%2C%20suspenseful%20tension%2C%20realistic%20style%2C%20no%20text&width=600&height=800&seq=latest-2&orientation=portrait',
    rating: 8.7,
    year: 2026,
    description: '境外诈骗团伙死灰复燃，这一次他们盯上了AI技术...',
    tags: ['犯罪', '剧情', '社会'],
    updateInfo: '更新至高清完整版',
  },
  {
    id: 9,
    title: '奔跑吧兄弟12',
    slug: 'benpaoba12',
    category: '综艺',
    categorySlug: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%20in%20a%20colorful%20outdoor%20setting%2C%20energetic%20vibe%2C%20bright%20sunny%20day%2C%20entertainment%20style%2C%20no%20text&width=600&height=800&seq=latest-3&orientation=portrait',
    rating: 8.3,
    year: 2026,
    description: '全新常驻阵容，横跨全国十座城市的欢乐冒险...',
    tags: ['综艺', '户外', '竞技'],
    updateInfo: '更新至第6期',
  },
  {
    id: 10,
    title: '大奉打更人',
    slug: 'dafengdagengren',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%2C%20a%20warrior%20in%20ancient%20armor%20holding%20a%20sword%20under%20a%20full%20moon%2C%20mystical%20energy%20glowing%2C%20dark%20forest%20background%2C%20epic%20style%2C%20no%20text&width=600&height=800&seq=latest-4&orientation=portrait',
    rating: 8.6,
    year: 2026,
    description: '许七安穿越到大奉王朝，凭借现代知识在朝堂与江湖间周旋...',
    tags: ['古装', '奇幻', '喜剧'],
    updateInfo: '更新至第28集',
  },
  {
    id: 11,
    title: '独行月球2',
    slug: 'duxingyueqiu2',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20sci-fi%20movie%20poster%2C%20a%20lone%20astronaut%20on%20the%20moon%20surface%20with%20earth%20in%20background%2C%20humorous%20tone%2C%20bright%20lunar%20landscape%2C%20cinematic%20style%2C%20no%20text&width=600&height=800&seq=latest-5&orientation=portrait',
    rating: 8.4,
    year: 2026,
    description: '时隔三年，独孤月再次踏上月球。这一次他不是一个人在战斗...',
    tags: ['喜剧', '科幻', '冒险'],
    updateInfo: '即将上映',
  },
  {
    id: 12,
    title: '凡人修仙传',
    slug: 'fanrenxiuxianzhuan',
    category: '动漫',
    categorySlug: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20cultivation%20series%20poster%2C%20a%20young%20cultivator%20flying%20on%20a%20sword%20above%20misty%20mountains%2C%20spiritual%20energy%20effects%2C%20traditional%20Chinese%20painting%20style%2C%20no%20text&width=600&height=800&seq=latest-6&orientation=portrait',
    rating: 8.8,
    year: 2026,
    description: '韩立踏入灵界，面对完全陌生的修仙世界，一切从零开始...',
    tags: ['动画', '修仙', '热血'],
    updateInfo: '更新至第52集',
  },
];

export const TOP_RATED_CONTENT: ContentItem[] = [
  {
    id: 13,
    title: '漫长的季节',
    slug: 'manchangdejijie',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20drama%20poster%2C%20autumn%20leaves%20falling%20in%20an%20old%20industrial%20town%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20light%2C%20melancholic%20mood%2C%20artistic%20cinematography%2C%20no%20text&width=600&height=800&seq=top-1&orientation=portrait',
    rating: 9.4,
    year: 2023,
    description: '一座北方小城，一桩跨越二十年的悬案，三个不同时代的命运交织...',
    tags: ['悬疑', '剧情', '家庭'],
    updateInfo: '全12集',
  },
  {
    id: 14,
    title: '让子弹飞',
    slug: 'rangzidanfei',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20western%20action%20comedy%20movie%20poster%2C%20a%20bandit%20chief%20in%20traditional%20Chinese%20clothing%20holding%20a%20gun%2C%20desert%20town%20background%2C%20dramatic%20composition%2C%20bold%20colors%2C%20no%20text&width=600&height=800&seq=top-2&orientation=portrait',
    rating: 9.0,
    year: 2010,
    description: '北洋年间，南部中国。一场惊天动地的火车劫案，一个土匪冒充县长的传奇故事...',
    tags: ['剧情', '喜剧', '动作'],
    updateInfo: '高清修复版',
  },
  {
    id: 15,
    title: '琅琊榜',
    slug: 'langyabang',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20a%20scholar%20in%20white%20robes%20standing%20on%20a%20mountain%20peak%2C%20misty%20landscape%2C%20elegant%20and%20refined%20aesthetic%2C%20classical%20Chinese%20art%20style%2C%20no%20text&width=600&height=800&seq=top-3&orientation=portrait',
    rating: 9.3,
    year: 2015,
    description: '十二年前七万赤焰军被奸人所害，少帅林殊侥幸生还。十二年后他改头换面...',
    tags: ['古装', '权谋', '剧情'],
    updateInfo: '全54集',
  },
  {
    id: 16,
    title: '我不是药神',
    slug: 'wobushiyaoshen',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20social%20drama%20movie%20poster%2C%20a%20middle-aged%20man%20looking%20at%20medicine%20bottles%20with%20a%20serious%20expression%2C%20warm%20natural%20lighting%2C%20realistic%20portrait%20style%2C%20emotional%20depth%2C%20no%20text&width=600&height=800&seq=top-4&orientation=portrait',
    rating: 9.0,
    year: 2018,
    description: '一位保健品店主从印度代购白血病特效药的故事，折射出人性的光辉与无奈...',
    tags: ['剧情', '社会', '喜剧'],
    updateInfo: '高清完整版',
  },
];